import React from 'react'
import { ProductLights } from '../_shared/ProductLights'
import { LIGHT_COLORS } from '../_shared/lightColors'
import type { LightSpec, LightsProps } from '../types'

// User-tuned via debug panel (scene-debug dump 2026-06-13).
const rig: LightSpec[] = [
  // Spot — top-down over front-left corner
  { type: 'spot', position: [-60, 350, 450], target: [-60, 0, 450], intensity: 1, angle: 1.02, penumbra: 0.3, distance: 0, decay: 0, color: LIGHT_COLORS.neutralWarm },
  // Spot — top-down over back-left corner
  { type: 'spot', position: [10, 350, 120], target: [10, 0, 120], intensity: 1, angle: 1.02, penumbra: 0.3, distance: 0, decay: 0, color: LIGHT_COLORS.neutralWarm },
  // Spot — top-down over back-right corner
  { type: 'spot', position: [220, 350, 120], target: [220, 0, 120], intensity: 1, angle: 1.02, penumbra: 0.3, distance: 0, decay: 0, color: LIGHT_COLORS.neutralWarm },
  // Spot — top-down over front-right corner
  { type: 'spot', position: [150, 350, 450], target: [150, 0, 450], intensity: 1, angle: 1.02, penumbra: 0.3, distance: 0, decay: 0, color: LIGHT_COLORS.neutralWarm },
  // Point — warm underfill from below
  { type: 'point', position: [50, -260, 230], intensity: 1, color: LIGHT_COLORS.neutralWarm },
  // Ambient
  { type: 'ambient', intensity: 0.35, color: LIGHT_COLORS.neutral },
  // Directional — neutral key from back-left
  { type: 'directional', position: [10, 300, -430], target: [460, 260, 1690], intensity: 0.7, color: LIGHT_COLORS.neutral },
  // Cool narrow accent from front-right
  { type: 'spot', position: [320, 190, 130], target: [-60, -20, -80], intensity: 0.6, angle: 0.6, penumbra: 1, distance: 0, decay: 0, color: LIGHT_COLORS.coldKey7500 },
  // Warm narrow accent from front-left
  { type: 'spot', position: [-160, 160, 200], target: [-60, 50, 0], intensity: 0.6, angle: 0.6, penumbra: 1, distance: 0, decay: 0, color: LIGHT_COLORS.warmFill },
]

export const Lights: React.FC<LightsProps> = (props) => (
  <ProductLights rig={rig} {...props} />
)
